/*eslint-disable*/
import { useState, useEffect } from "react";

// services
import { fetchGroup } from '../../services/groups';

const useGroup = (groupId) => {
    const [group, setGroup] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const getGroup =async () => {
        try {
            const {data: groupResponse } = await fetchGroup(groupId) || {};
            setGroup(groupResponse);
          } catch (error) {
            //toast.error(error.message)
           
          } finally {
            setIsLoading(false)
          }
    };

    useEffect(() => {
        getGroup()
    }, []);

    

    return { group, isGroupLoading: isLoading, getGroup, setGroup }
};

export default useGroup